module.exports = __webpack_public_path__ + "img/contentImg7.565b25c.png";